import mappedItemTypes from "services/items/mappedItemTypes";
import { PCW_STEPS } from "../constants";
import { PortfolioItemSelectStep } from "../PortfolioItemSelectStep";

export default function RenewablesStep() {
  return (
    <PortfolioItemSelectStep
            stepId={PCW_STEPS.PCW_ADD_RENEWABLES_STEP_ID}
            itemTypeIds={[
                mappedItemTypes.WIND_ASSET.id,
            ]}
        />
  )
}
